import React from 'react';

type Props = {
    children: any;
    numberOfChildren: any;
    selectedIndex: number;
};

export default function SwitchContainer(props: Props) {
    const { numberOfChildren, selectedIndex } = props;

    return (
        <div className={"w-full p-2 rounded-full flex gap-2 bg-primary-50 mb-4 h-16 relative"}>
            <div
                className={`items-center w-1/${numberOfChildren} h-12 flex justify-center rounded-full border cursor-default bg-white border-primary-600 transition-all`}
                style={{
                    width: 1 / numberOfChildren * 100 + "%",
                    transform: "translateX(" + selectedIndex * 100 + "%)"
                }}
            >
            </div>
            <div className={"absolute left-2 w-[calc(100%-1rem)] flex justify-around"}>
                {props.children}
            </div>
        </div>
    );
}